import script from './SubtleLinkExternal.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"subtle-link",attrs:{"href":_vm.link,"target":"_blank"}},[_c('span',{staticClass:"subtle-link__text"},[_vm._t("default",function(){return [_vm._v("\n            "+_vm._s(_vm.text)+"\n        ")]},{"text":_vm.text})],2),_vm._v(" "),_c('Icon',{staticClass:"icon-arrow_right",attrs:{"size":"sm"}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-140cef08_0", { source: ".subtle-link[data-v-140cef08]{display:flex;font-weight:600;font-size:12px;line-height:16px;color:#999;cursor:pointer}.subtle-link[data-v-140cef08]:hover{color:#777}.subtle-link__text[data-v-140cef08]{margin-right:8px}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-140cef08";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
